function updateLengthsUI(standard,premium){
  /**
  $('.fullness-options').length)
  if('premium'){
    var lenghts_main = '';
    var lengths_premium = '';
    
  }
  else if('standard'){
    
  }
  **/
}

	function gaEventProduct(category,action,label)
	{
		try {
			ga('send', 'event', {
				eventCategory: category,
				eventAction: action,
				eventLabel: label
			});
          console.log('---------gaEventProduct '+action+' ----------');
		}
		catch (gaerr) { }
	}
  
	function gaPageviewProduct(page)
	{
		try {	
			ga('send', 'pageview', page);
		}
		catch (gaerr) { }
	}


$( document ).ready(function() {

  
  	window.showWasPrice = function(wasPrice) {

        try {
          var currency = $('#money_currency').val();
          var wasPriceMoney = Shopify.formatMoney(wasPrice,currency);
          $('.was-price').show().css('display','inline-block');
          $('.old-price-value').html(wasPriceMoney);

        }
        catch (processFullnessUIERR) {
            console.log(processFullnessUIERR);
        }
  	}
    
  	window.showWidths = function(widths) {

        try {
          var widthsObj = $('.calculated_widths');
          if(widthsObj.length){
            var widths_msg = "1 width";
            if(widths > 1){
              var widths_msg = widths +" widths";
            }
          	$('.calculated_widths').show().find('.calculated_widths_count').html(widths_msg);
          }

        }
        catch (showWidthsERR) {
            console.log(processFullnessUIERR);
        }
  	}

    window.processFullnessShowHide = function(mode) {
        try {
            var fullnessObj = $('.product-section-fullness-container');
            if(mode == 'show'){
                console.log('SHOW processFullnessUI');
                   fullnessObj.show();
                   fullnessObj.find('input').each(function () {
                          var thisObj1 = $( this );
                           thisObj1.prop('disabled', false);
                          if (thisObj1.parent('.iradio_flat-blue').length){
                              thisObj1.parent('.iradio_flat-blue').removeClass('disabled');
                          } 
                    });
                    $('.standard-lengths-used').show();
                    $('.premium-lengths-used').show();
            }
            else if (mode == 'hide'){
              console.log('HIDE processFullnessUI');
               fullnessObj.hide();
               fullnessObj.find('input').each(function () {
                      var thisObj1 = $( this );
                       thisObj1.prop('disabled', true);
                      if (thisObj1.parent('.iradio_flat-blue').length){
                          thisObj1.parent('.iradio_flat-blue').removeClass('disabled').addClass('disabled');
                      } 
                });
                $('.standard-lengths-used').hide();
                $('.premium-lengths-used').hide();
            }
        }
        catch (processFullnessShowHideERR) {
            console.log(processFullnessShowHideERR);
        }
    }
    window.processFullnessUI = function(standardWidths,standardPrice,standardWasPrice, premiumWidths,premiumPrice,premiumWasPrice) {  
 
        try {
          console.log('processFullnessUI 1');
          processFullnessShowHide('hide');
		  var currency = $('#money_currency').val();
		  var standardPriceMoney;
          var standardWasPriceMoney;
          var premiumPriceMoney;
          var premiumWasPriceMoney;
          
          if ((standardWasPrice > 0) && (standardWasPrice < standardPrice)) {
                //Was
                var standardWasPriceMoney = Shopify.formatMoney(standardWasPrice,currency);
                $('.standard-lengths-wasprice').html(standardWasPriceMoney).show();
            	console.log('------ standardWasPriceMoney ' + standardWasPrice +' -------');
          }
          else {
                $('.standard-lengths-wasprice').html('').hide();
            	console.log('------ standard WasPriceMoney hide ' + standardWasPrice + '------');
          }     
          
          
          


          if(premiumWidths != false) {

            if ((premiumWasPrice > 0) && (premiumWasPrice < premiumPrice)) {
                //Was
              	var premiumPriceMoney = Shopify.formatMoney(premiumPrice,currency);
                jQuery('.premium-lengths-wasprice').html(premiumPriceMoney).show();
              	console.log('------ premiumWasPriceMoney 1 ' + premiumPrice +' -------');

            }
            else {
                jQuery('.premium-lengths-wasprice').html('').hide();
              	console.log('------ premiumWasPriceMoney hide ' + premiumPrice +' -------');
            }
            
            
            jQuery('.standard-lengths-count').html(standardWidths);
            jQuery('.premium-lengths-count').html(premiumWidths);

            standardPriceMoney = Shopify.formatMoney(standardPrice,currency);
            premiumPriceMoney = Shopify.formatMoney(premiumPrice,currency);

            jQuery('.standard-lengths-price').html(standardPriceMoney);
            jQuery('.premium-lengths-price').html(premiumPriceMoney);            
            
          	processFullnessShowHide('show');               
            
          }//End if premium widths
		     

        }
        catch (processFullnessUIERR) {
            console.log(processFullnessUIERR);
        }
	}
    
    window.updateBlindRodsInfo = function(rodinfo) {   
        try {
          jQuery('#properties-rods').val(rodinfo);
        }
      	catch (updateBlindRodsInfoERR) {
            console.log(updateBlindRodsInfoERR);
        }
	}  
    
    window.updateRollerblindsInfo = function(wg, dg, vg) {   
        try {
          jQuery('#roller_wg').val(wg);
          jQuery('#roller_dg').val(dg);
          jQuery('#roller_vg').val(vg);          
        }
      	catch (updateRollerblindsInfoERR) {
            console.log(updateRollerblindsInfoERR);
        }
	} 
  
    if($('#properties-colour').length) {
      
      $('#properties-colour').on('change', function (e) {
          var optionSelected = $("option:selected", this);
          var valueSelected = this.value;
          //hide options not related to selected color 
      });
      
  	}
    
    setLength($('#properties-colour option:selected').val());
  
	function setLength(colourValue){
		$("#properties-length option").removeClass('none').addClass('none');
		$("#properties-length option").attr('disabled','disabled');
		$("#properties-length option").each(function() {
			var colour = $(this).attr('colour');
			if (colour == colourValue){
				$(this).removeAttr('disabled').removeClass('none');
			}
		});
	}
  
  	/* ------------------- CURTAIN STYLE ----------------------------- */
  	
  	$('.eyelet-size-radio').on('ifChecked', function(event){
		handle_eyelet(this.id);
	});
  	
    $('input').on('ifChecked ', function(event){
      console.log('-----isChanged-----');
      handle_cm_inch($('#add-item-form'));
        setTimeout(function () {
          validate_this_then_calculate($('#add-item-form'));
        }, 100);
	});

  	$('#add-item-form').on('keyup change', ':input, select, textarea', function(){
      console.log('-----isChanged-----');
      handle_cm_inch($('#add-item-form'));
        setTimeout(function () {
          validate_this_then_calculate($('#add-item-form'));
        }, 100);
    });
  
    function handle_eyelet(thisObj){
      	console.log("handle_eyelet");
      	$('.eyelets-wrap').hide();
        $('.eyelets-wrap').find('input').each(function () {
        	var thisObj1 = $( this );
             thisObj1.prop('disabled', true);
        });
      	console.log("handle_eyelet each..");
      	if ($('.eyelet-size-radio[type=radio]:checked').length){
            var size = $('.eyelet-size-radio[type=radio]:checked').val();
            size = size.toLowerCase();
            console.log('size =' +size);

            if(size == 'large'){
                console.log(' standard size ');
                $('.large-eyelets').find('input').each(function () {
                    var thisObj1 = $( this );
                     thisObj1.prop('disabled', false);
                });
                $('.standard-eyelets').find('input').each(function () {
                    var thisObj1 = $( this );
                     thisObj1.prop('checked', false);
                });
                $('.large-eyelets').show();
            }
            else if (size == 'standard'){
                console.log(' large size ');
              
                $('.standard-eyelets').find('input').each(function () {
                    var thisObj1 = $( this );
                     thisObj1.prop('disabled', false);
                });
                $('.large-eyelets').find('input').each(function () {
                    var thisObj1 = $( this );
                     thisObj1.prop('checked', false);
                });
                $('.standard-eyelets').show(); 	
            }
        }
    }
  	
  	if($('.curtain-style-choose input[type=radio]').length) {
      $(document).on('change', ".curtain-style-choose input[type=radio]", function() { 
      //$('.curtain-style-choose input[type=radio]').change(function() {       
          var selected_style = this.value;
          show_sections_for_curtain_style('300');
      });
      
    }
  
    function show_sections_for_curtain_style(time){
      	$('.pleat-dependant').hide('200');
      	if ($('.curtain-style-choose input[type=radio]').length){
          if ($('.curtain-style-choose input[type=radio]:checked').length){
            var thisObj = $('.curtain-style-choose input[type=radio]:checked');
            var style = thisObj.val();
            //hide pleat dependants
            $('.pleat-dependant').hide('200');
            $('.pleat-dependant').find('input').each(function () {
                  var thisObj1 = $( this );
                  thisObj1.prop('disabled', true);
                  if (thisObj1.parent('.iradio_flat-blue').length){
					thisObj1.parent('.iradio_flat-blue').removeClass('disabled');
                  }
              		
            });
            var styleHandelised = style.toLowerCase().replace(' ','-')+'-show';
            console.log('we are in  '+styleHandelised+' mode   '+ $('.'+styleHandelised).length);
            //show selected pleat dependants 
            $('.'+styleHandelised).show('200');
            $('.'+styleHandelised).find('input').each(function () {
                  var thisObj2 = $( this );
                  thisObj2.prop('disabled', false);
                  if (thisObj2.parent('.iradio_flat-blue').length){
					thisObj2.parent('.iradio_flat-blue').removeClass('disabled');
                  }
            });
            switch (style) {
                  case "Tab Top":
                      break;
                  case "Eyelet":

                      handle_eyelet(thisObj.attr('id'));
                      break;
                  case "Pencil Pleat":
                      break;
                  case "Wave Pleat":
                      break;
                  case "Double Pinch Pleat":
                  case "Triple Pinch Pleat":
                      break;
            }
          }
        }
        else{
        }
    }
	
  	/* ------------------- CURTAIN STYLE END ----------------------------- */
  	/* ------------------- CURTAIN FROM VALIDATE ------------------------ */
	
  
    function check_radio_btn(thisObj){
    	var this_name = thisObj.attr('name');
      	//validate_this_then_calculate($('[name="'+this_name+'"]'));
        setTimeout(function () {
          validate_this_then_calculate($('[name="'+this_name+'"]'));
        }, 100);
    }
  
    function chainpull_side(){
      
      	try {
          console.log('------------------ chainpull_side ------------------');
          var formid = $('#add-item-form');
          if ($('input[name="properties[Chain-Pull-Side]"]:checked', formid).length){
            	
                var side = $('input[name="properties[Chain-Pull-Side]"]:checked', formid).val();
              	console.log('------------------ '+ side +' ------------------');
                if( side == 'left' ){

                  $('body').removeClass('blind-left').removeClass('blind-right').addClass('blind-left');

                }
                else if ( side == 'right' ){

                  $('body').removeClass('blind-left').removeClass('blind-right').addClass('blind-right');

                }

            }
        }
        catch (errchainpull_side) {
        	console.log(errchainpull_side);
        }
    }

    /** ----------------- BOX SEAT COVER --------------------- **/
  
  	if($('#properties-foam').length) {
      $(document).on('change', "#properties-foam", function() {
      //$('#properties-foam').change(function() {  
          var thevalue = this.value;
          if (this.value == 0) {
		  	//$('#properties-custom-depth').prop("disabled", false).parents('.hidden-option').show();
            $('#properties-custom-depth').parents('.hidden-option').show();
          }
          else {
			//$('#properties-custom-depth').prop("disabled", true).parents('.hidden-option').hide();
            $('#properties-custom-depth').parents('.hidden-option').hide();
          }
          try {
          	$('#properties-custom-depth').change();
          	setTimeout(function () {
          		$('#properties-custom-depth').change();
          	}, 500);
          }
          catch (err_properties_box_cd) {
          }
      });     
    }
  
    /** ----------------- BOX SEAT COVER --------------------- **/
  
  	/** ----------------- STANDARD CALC FUNCTIONS --------------------- **/
    $('#add-item-form').validate({
		onkeyup: false,
		showErrors: function(errorMap, errorList) {
          	if (window.calculated) {
              this.defaultShowErrors();             
            }
            console.log('errorList ='+ errorList);
		},
		invalidHandler: function(event, validator) {
          if (window.calculated) {
			// 'this' refers to the form
			var errors = validator.numberOfInvalids();
           	//console.log('errors = '+errors);
 			if (errors) {
          		var message = errors == 1
            	$(".error-summary-subtitle").html(message);
          		$('.error-summary').show();
            	$('.calculate-section').attr('disabled','disabled');
         	} else {
           		$('.calculate-section').removeAttr('disabled');
            	$('.calculate-section').fadeOut('300',function() {
          			$('.calculated-section').fadeIn('300');
                    var calculated_price = calculatePrice($('#add-item-form'));
                    $('.calculated-section-price .price').html(calculated_price);

                    var calcprice = ((parseFloat(calculated_price))*0.01).toFixed(2);
                    console.log("calculated_price (1): "+calculated_price+" "+calcprice);
                    //$('#product_check').val(calcprice);
          		});
          	}
          }
    	}
	});
	/**
    function handle_cm_inch(unit){
      console.log('handle_cm_inch');
      var unitAttr = 'mincm';
      if(unit == 'cm'){
            unitAttr = 'mincm';
      }
      else if (unit == 'inch'){
            unitAttr = 'mininch';
      }
      var minLength = parseInt($('[name="properties[Track-Length]"]').attr(unitAttr), 10);
      var minDrop = parseInt($('[name="properties[Drop]"]').attr(unitAttr), 10);
      var lengthMsg = $('[name="properties[Track-Length]"]').attr('msg-tmpl')+minLength+unit;
      var dropMsg = $('[name="properties[Drop]"]').attr('msg-tmpl')+minLength+unit;
    
      $('[name="properties[Track-Length]"]').attr('min',minLength);
      $('[name="properties[Drop]"]').attr('min',minDrop);
      $('[name="properties[Drop]"]').attr('data-msg-min',dropMsg)
      $('[name="properties[Track-Length]"]').attr('data-msg-min',lengthMsg);
      $('input.refreshminmsg').each(function () {
        var newmsg = $(this).attr('data-msg-min');
        validator.rules('add', {
            messages: {
                min: newmsg
            }
        });
      });
    }
    **/
  
	try {
  		$( document ).ready(function() {
      		validate_this_then_calculate($('#add-item-form'));
    	});
	}
	catch (errvttc) {}
  
  	window.trackcalculated = 'no';
  
    function additional_items(){
      
		var additionalcost = 0;
		var currency = $('#money_currency').val();
      
		if ($('#additional-item-cost').length){
          
          	var additionalitemtitle = $('#additional-item-cost').attr('title');
          	var additionalitemmultiple = $("#additional-item-quantity").val();
			var additionalcost = $('#additional-item-cost').val() * additionalitemmultiple;
          	var formated_price = Shopify.formatMoney(additionalcost,currency);
            if (additionalitemmultiple > 0){

                var additionalsinglecost = (Math.ceil(parseFloat($('#additional-item-cost').val())) * 0.01).toFixed(2);
                $('#product_extra_check').val(additionalsinglecost);
              
            	$("#additonal-item-quantity").text(additionalitemmultiple);
              	
                $('.calculated-additional-multiple').html(additionalitemmultiple);
                $('.calculated-additional-title').html(additionalitemtitle);
                $('.calculated-additional-price').html('('+formated_price+')');
              	$("#additonal-item-sub").show();
              	$('.calculated-main-price').show();
              	return additionalcost;
              
            }
            else{
				additionalcost = 0;
            }
		}
      	else{
          	additionalcost = 0;
      	}
        if(additionalcost > 0){
        	$("#additonal-item-sub").show();
            $('.calculated-main-price').show();
        }
        else{
			$("#additonal-item-sub").hide();
           	$('.calculated-main-price').hide();
        }
        
      	return additionalcost;
      	
    }
  
  
    function validate_this_then_calculate(thisObj){
     
      //console.log(thisObj.attr('id'));
      //alert('validate_this_then_calculate');
      chainpull_side();
      handle_cm_inch(thisObj);
      if(thisObj.valid()){
        //console.log('is valid');
        $('.error-summary').hide(); 
        $('.calculate-section').removeAttr('disabled');
      	$('.calculate-section').fadeOut('300',function() {
          	var quantity = 1;
          	if ($("[name='quantity']").length){
          		var quantity = $("[name='quantity']").val();
              	$('.calculated-section-summary-multiple').hide();
          		$('.calculated-section-summary-multiple-inner').html('x'+quantity);
                if (quantity > 1){
                    $('.calculated-section-summary-multiple').show().css('display','inline-block');
                }
            }
          	var additionalcost = additional_items();
          	//alert('additional-item-cost =' + $('#additional-item-cost').val() + ' | additional-item-quantity =' + $("#additional-item-quantity").val());
          	$('.calculated-section').fadeIn('50');
          	var currency = $('#money_currency').val();
        	var calculated_price = calculatePrice(thisObj);
          	if($('.calculated-main-price').length){
               var mainprice = Shopify.formatMoney(calculated_price,currency)
               $('.calculated-main-price').attr('data-mainprice',mainprice).html('('+mainprice+')');
               var calcprice = ((parseFloat(calculated_price))*0.01).toFixed(2);
               console.log("calculated_price (2): "+calculated_price+" "+calcprice);
               //var eachcheckprice = (calcprice * (1/parseFloat(quantity))).toFixed(2);
               //$('#product_check').val(eachcheckprice);
              
               //$('.calculated-main-price').attr('data-mainprice',mainprice);
            }
          	calculated_price = calculated_price + additionalcost;
          	//alert(calculated_price);
          	window.calculated = true;
          	calculated_price = Shopify.formatMoney(calculated_price,currency);
            if (window.trackcalculated == 'no'){
        		gaEventProduct('Product','Calculate Price',calculated_price);
        		window.trackcalculated = 'yes';
              
                try {
                  if (typeof fbq !== 'undefined') {
                      fbq('track', 'CalculatePrice');
                  }
                }
                catch (catch_calculatePrice_err) {
                    console.log(catch_calculatePrice_err.message);
                }
      		}
          	$('.calculated-section-price .price').html(calculated_price).parents('.calculated-section-price').show();
		});
      }
      else {
        if (window.calculated) {
          //console.log('not valid');
          $('.error-summary').show(); 
          $('.calculated-section').fadeOut('300',function() {
              $('.calculate-section').fadeIn('50');
          });
        }
      }
    }
  
  	if($('.calculate-on-change').length) {
      $(document).on('change', ".calculate-on-change", function() {              
          setTimeout(function () {
          	validate_this_then_calculate($('#add-item-form'));
          }, 100);
      });     
      $('.calculate-on-change').change(function() {       
          setTimeout(function () {
          	validate_this_then_calculate($('#add-item-form'));
          }, 100);
      });     
    }
  
    function process_min_max_messages(thisObj,minormax,unit){
		var siblingObj = thisObj.prev();
        var thisvalue = parseInt(thisObj.attr(minormax+'cm'),10)+0;
      	console.log('process_min_max_messages = "'+minormax+'" "'+thisvalue+'" cm to "'+unit+'"');
		if (thisObj.is('['+ minormax + '-msg-tmpl]')){
            if (unit == 'inch'){
                //console.log('thisvalue before = '+thisvalue);
              	if (minormax == 'max'){
                  	thisvalue = Math.floor(thisvalue/2.54);
              	}
              	else {
              		thisvalue = Math.ceil(thisvalue/2.54);
              	}
                //console.log('thisvalue = '+thisvalue);
              	console.log('process_min_max_messages = "'+minormax+'" "'+thisvalue+'" inches');
            }
			var msgtmpl = thisObj.attr(minormax + '-msg-tmpl');
            var datamsg = msgtmpl + ' ' + thisvalue + ' ' + unit;
            siblingObj.find('.' + minormax + 'value').text(thisvalue);
            siblingObj.find('.' + minormax + 'unit').text(unit);
            thisObj.attr(minormax,thisvalue);
            thisObj.attr('data-msg-'+minormax,datamsg);
          	console.log('data-msg-' + minormax+ ' | ' + thisObj.attr('data-msg-'+minormax));
            if (minormax == 'min') {
              console.log('min datamsg set = ' + datamsg);
              thisObj.rules("remove", "min");
              thisObj.rules('add', {
                  min: thisvalue,
                  messages: {
                      min: datamsg
                  }
              });
            }
            if(minormax == 'max') {
              console.log('max datamsg set = ' + datamsg);
              thisObj.rules("remove", "max");
              thisObj.rules('add', {
                  max: thisvalue,
                  messages: {
                      max: datamsg
                  }
              });
            }
		}
    }
 
    function handle_cm_inch(formObj){
      	console.log('handle_cm_inch');
      
      	if($('input[name="properties[Unit]"]').length){
          var selected_unit = "";
          if (typeof $('input[name="properties[Unit]"]:checked', formObj).val() != 'undefined') {
          	selected_unit = $('input[name="properties[Unit]"]:checked', formObj).val();
          }
          else if (typeof $('input[name="properties[Unit]"]', formObj).val() != 'undefined') {
          	selected_unit = $('input[name="properties[Unit]"]', formObj).val();
          }
          selected_unit = selected_unit.toLowerCase();
          console.log('selected_unit = '+selected_unit);
          if (selected_unit == 'inches' || selected_unit == 'inch' ){
              selected_unit = 'inch';
          }
          $('.unit-warning-update').each(function () {
              var thisObj = $( this );
              var objID = $( this ).attr('id');
              var siblingObj = thisObj.prev();
			  process_min_max_messages(thisObj,'min',selected_unit);
			  process_min_max_messages(thisObj,'max',selected_unit);
          });
    	}
    }
  
  	var seenliningWarning = 'no';
  
  	function liningWarning() {
        try {
          if(seenliningWarning == 'no'){
              var lining_content = $('.no-lining-msg').html();
              $.Zebra_Dialog(lining_content, {
                  type: 'none',
                  width: 400,
                  title:  'No Lining?'
              });
              seenliningWarning = 'yes';
          }
        }
        catch (processFullnessUIERR) {
            console.log(processFullnessUIERR);
        }
  	}
  
  	if ($('#properties-lining').length) {
      $(document).on('change', "#properties-lining", function() { 
      //$('#properties-lining').change(function() {       
          var selectedunit = $(this).find(":selected").attr('lining-unit');
          var selectedvalue = $(this).find(":selected").val();
          console.log('------- lining is '+selectedvalue+' -------');
          $('#Lining-Unit').val(selectedunit);
          if (selectedvalue == 'none'){
            console.log('------- lining is none -------');
			 liningWarning();
          }
          validate_this_then_calculate($('#add-item-form'));
      });
      
    }
  
  	/** ----------------- STANDARD CALC FUNCTIONS --------------------- **/
	
    show_sections_for_curtain_style('0');
  
  
	$('body').on("click",'.calculate-button',function() {
      	window.calculated = true;
        setTimeout(function () {
          validate_this_then_calculate($('#add-item-form'));
        }, 100);
	});
  
  	//check if we are calculating on page load
    if($('#auto_calculate').length){
      	//alert('####### auto_calculate #######');
        setTimeout(function () {
          validate_this_then_calculate($('#add-item-form'));
        }, 100);
    }
  	 
    $('.error-label').each(function () {
      	var thisObj = $( this );
      	$( ".calculate-errors-msg" ).each(function () {
			thisObj.clone().appendTo( $(this) );
        });
    });
    
});